import React from 'react';
import classNames from 'classnames';
import './index.scss';

import {ErrorData} from '../../../utils/sagaHelper';
import {columnIsRequired} from '../../../services/filter';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon';
import IconButton from '../IconButton';
import {getTranslateTitle} from "../../../utils/objects-util.js";
import { DebounceInput } from "react-debounce-input";

const SectionItemText = ({ column, item, value, error, onPropChange, withTitle = true, type, fullItem }) => {
  const isItemValid = column && column?.isItemValid ? !column.isItemValid(item, fullItem) : false;
  const translateTitle = column.placeholder ? getTranslateTitle(column.placeholder) : '';
  const handleOnPropChange = e =>
    onPropChange(
      !e.target.value || !column.pattern || column.pattern.test(e.target.value)
        ? { [column.accessor]: e.target.value }
        : new ErrorData(column.patternError || 'Wrong data!')
    );

  const onClickFormated = () => {
    onPropChange({ [column.accessor]: column.formatedFn() });
  };

  return (
    <div
      key={`sectionItemText-${column.accessor}`}
      className={classNames('sectionItemText', column.inlineType, {
        withFormated: column.formatedFn,
        isReadonly: column.isReadonlyFn ? column.isReadonlyFn(item) : column.isReadonly,
        required: columnIsRequired(column, item, fullItem) || isItemValid,
        inherited: column.showInherited ? column.showInherited(item) : false,
      })}
    >
      {withTitle && <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />}
      <form
        autoComplete='off'
        className={classNames('inputItem', {
          required: columnIsRequired(column, item, fullItem) || isItemValid,
          withoutBorder: column?.withoutBorder,
        })}
      >
        <DebounceInput
          debounceTimeout={column.debounce || 0}
          type={type ? type : column.inputType ? column.inputType : 'text'}
          className={classNames({ hasError: column.hasError && column.hasError(error) })}
          placeholder={translateTitle}
          autoComplete='new-password'
          value={value ?? ''}
          style={{width: column?.width}}
          readOnly={column.isReadonly}
          minLength={column.minlength}
          maxLength={column.maxLength}
          onChange={handleOnPropChange}
        />
        {column.formatedFn && (
          <IconButton
            isIcon
            onClick={onClickFormated}
            iconName={column.formatedIcon}
            tooltipText={column.firmatedIconTooltip}
          />
        )}
        {column.icon && (column.isShowIcon ? column.isShowIcon(item) : true) && (
          <IconButton
            isIcon
            iconName={column.icon}
          />
        )}
      </form>
    </div>
  );
};

export default SectionItemText;
